import * as yup from 'yup';

import { fieldStateYupValidation } from '@/shared/utils/validationSchema';

export const agendamientoFormSchema = yup.object({
  numero_referencia: yup
    .string()
    .required('El campo numero referencia es requerido')
    .max(200, 'El campo numero referencia no debe exceder los 200 caracteres'),
  estado_agendamiento: yup
    .string()
    .required('El campo estado agentamiento es requerido')
    .max(
      200,
      'El campo estado agentamiento no debe exceder los 200 caracteres'
    ),
  celular: yup
    .string()
    .required('El campo celular es requerido')
    .max(200, 'El campo celular no debe exceder los 200 caracteres'),
  celular_2: yup
    .string()
    .required('El campo celular 2 es requerido')
    .max(200, 'El campo celular 2 no debe exceder los 200 caracteres'),
  email: yup
    .string()
    .required('El campo email es requerido')
    .max(200, 'El campo email no debe exceder los 200 caracteres'),
  direccion: yup
    .string()
    .required('El campo direccion es requerido')
    .max(200, 'El campo direccion no debe exceder los 200 caracteres'),
  coordenadas: yup
    .string()
    .required('El campo coordenadas es requerido')
    .max(200, 'El campo coordenadas no debe exceder los 200 caracteres'),
  distancia: yup
    .string()
    .required('El campo distancia es requerido')
    .max(200, 'El campo distancia no debe exceder los 200 caracteres'),
  fecha_instalacion: yup
    .string()
    .required('El campo fecha instalacion es requerido')
    .max(200, 'El campo fecha instalacion no debe exceder los 200 caracteres'),
  hora_instalacion: yup
    .string()
    .required('El campo hora instalacion es requerido')
    .max(200, 'El campo hora instalacion no debe exceder los 200 caracteres'),
  fecha_hora_instalacion: yup
    .string()
    .required('El campo fecha hora instalacion es requerido')
    .max(
      200,
      'El campo fecha hora instalacion no debe exceder los 200 caracteres'
    ),
  estado_llamada: yup
    .string()
    .required('El campo estado llamada es requerido')
    .max(200, 'El campo estado llamada no debe exceder los 200 caracteres'),
  fecha_hora_llamada: yup
    .string()
    .required('El campo fecha hora llamada es requerido')
    .max(200, 'El campo fecha hora llamada no debe exceder los 200 caracteres'),
  observaciones: yup
    .string()
    .required('El campo observaciones es requerido')
    .max(200, 'El campo observaciones no debe exceder los 200 caracteres'),
  url_foto_identificacion_delantera: yup
    .string()
    .required('El campo url foto identificacion delantera es requerido')
    .max(
      200,
      'El campo url foto identificacion delantera no debe exceder los 200 caracteres'
    ),
  url_foto_identificacion_posterior: yup
    .string()
    .required('El campo url foto identificacion posterior es requerido')
    .max(
      200,
      'El campo url foto identificacion posterior no debe exceder los 200 caracteres'
    ),
  url_foto_aceptacion: yup
    .string()
    .optional()
    .nullable()
    .max(
      200,
      'El campo url foto aceptacion no debe exceder los 200 caracteres'
    ),
  persona_referencia_nombre: yup
    .string()
    .required('El campo persona referencia nombre es requerido')
    .max(
      200,
      'El campo persona referencia nombre no debe exceder los 200 caracteres'
    ),
  persona_referencia_celular: yup
    .string()
    .required('El campo persona referencia celular es requerido')
    .max(
      200,
      'El campo persona referencia celular no debe exceder los 200 caracteres'
    ),
  persona_referencia_celular_2: yup
    .string()
    .required('El campo persona referencia celular 2 es requerido')
    .max(
      200,
      'El campo persona referencia celular 2 no debe exceder los 200 caracteres'
    ),
  persona_referencia_parentesco: yup
    .string()
    .required('El campo persona referencia parentesco es requerido')
    .max(
      200,
      'El campo persona referencia parentesco no debe exceder los 200 caracteres'
    ),

  estado: fieldStateYupValidation,

  codigo: yup.string().optional().nullable(),
  preagendamiento: yup
    .string()
    .required('El campo preagendamiento es requerido')
    .max(200, 'El campo preagendamiento no debe exceder los 200 caracteres'),
  flota: yup
    .string()
    .required('El campo flota es requerido')
    .max(200, 'El campo flota no debe exceder los 200 caracteres'),
  // nap: yup
  //   .string()
  //   .required('El campo nap es requerido')
  //   .max(200, 'El campo nap no debe exceder los 200 caracteres'),
  prospecto: yup
    .string()
    .required('El campo prospecto es requerido')
    .max(200, 'El campo prospecto no debe exceder los 200 caracteres'),
  preventa: yup
    .string()
    .required('El campo preventa es requerido')
    .max(200, 'El campo preventa no debe exceder los 200 caracteres'),
  cliente: yup
    .string()
    .required('El campo cliente es requerido')
    .max(200, 'El campo cliente no debe exceder los 200 caracteres'),
  contrato: yup
    .string()
    .required('El campo contrato es requerido')
    .max(200, 'El campo contrato no debe exceder los 200 caracteres'),
});

export const setEstadoLlamadaAgendamientoCellSchema = yup.object({
  estado_llamada: yup
    .string()
    .required('El campo estado llamada es requerido')
    .max(200, 'El campo estado llamada no debe exceder los 200 caracteres'),
  observacion_llamada: yup
    .string()
    .required('El campo observacion llamada es requerido')
    .max(
      200,
      'El campo observacion llamada no debe exceder los 200 caracteres'
    ),
});



export const agendamientoFormSchemaMinified = yup.object({
  estado_agendamiento: yup
    .string()
    .required('El campo estado agendamiento es requerido')
    .max(
      200,
      'El campo estado agentamiento no debe exceder los 200 caracteres'
    ),
  estado_llamada: yup
    .string()
    .required('El campo estado llamada es requerido')
    .max(200, 'El campo estado llamada no debe exceder los 200 caracteres'),
  observacion_llamada: yup
    .string()
    .required('El campo observacion llamada es requerido')
    // .max(
    //   200,
    //   'El campo observacion llamada no debe exceder los 200 caracteres'
    // ),
  /* fecha_instalacion: yup
    .string()
    .required('El campo fecha instalacion es requerido')
    .max(200, 'El campo fecha instalacion no debe exceder los 200 caracteres'),
  hora_instalacion: yup
    .string()
    .required('El campo hora instalacion es requerido')
    .max(200, 'El campo hora instalacion no debe exceder los 200 caracteres'),
  flota: yup
    .string()
    .required('El campo flota es requerido')
    .max(200, 'El campo flota no debe exceder los 200 caracteres'), */
});

export const newMotivoAgendaVentaSchema = yup.object({
  id_agendamiento: yup.string().required('Campo Obligatorio'),
  id_preagendamiento: yup.string().required('Campo Obligatorio'),
  motivo_rechazo: yup.string().required('Campo Obligatorio'),
});


export const newMotivoAgendaCorporativo = yup.object({
  flota: yup.string().required('Campo Obligatorio'),
  celular_1: yup.string().required('Campo Obligatorio'),
  estado_llamada: yup.string().required('Campo Obligatorio'),
  observacion_llamada: yup.string().required('Campo Obligatorio'),
  coordenada_fusion: yup.string().required('Campo Obligatorio'),
  coordenada_empresa: yup.string().required('Campo Obligatorio'),
  coordenada_servicio: yup.string().required('Campo Obligatorio'),
  fecha_instalacion: yup.string().required('Campo Obligatorio'),
  hora_instalacion: yup.string().required('Campo Obligatorio'),
  provincia: yup.string().required('Campo Obligatorio'),
  ciudad: yup.string().required('Campo Obligatorio'),
  //zona: yup.string().required('Campo Obligatorio'),
  //sector: yup.string().required('Campo Obligatorio'),
  direccion_servicio: yup.string().required('Campo Obligatorio'),
})


const isValidDate = (value: any) => {
  if (!value) return false; // Asegura que no esté vacío
  const date = new Date(value);
  return !isNaN(date.getTime()); // Retorna false si es "Invalid Date"
};

export const newRecordinarAgendaCorporativo = yup.object({
  flota: yup.string().required('Campo Obligatorio'),
  fecha_instalacion: yup.string().required('Campo Obligatorio'),
  hora_instalacion: yup.string()
    .test("is-valid-date", "Hora inválida", isValidDate)
    .required('Campo Obligatorio')
})

export const newRechazoGeneralSchema = yup.object({
  id: yup.string().required('Campo Obligatorio'),
  motivo_rechazo: yup.string().required('Campo Obligatorio'),
  observacion_cancelacion: yup.string().required('Campo Obligatorio'),
});